import * as React from 'react'

function SvgPk(props) {
	return (
		<svg viewBox="-75 -40 120 80" width="1em" height="1em" {...props}>
			<path fill="#fff" d="M-75-40H45v80H-75z" />
			<path fill="#01411C" d="M-45-40h90v80h-90z" />
			<circle r={24} fill="#fff" />
			<circle r={22} cx={-7} cy={-40} fill="#01411C" transform="rotate(-41.634 45 -40)" />
			<path
				fill="#fff"
				d="M8.751-17.959l10.11 11.373L3.997-9.844l13.94-6.1-7.692 13.129z"
			/>
		</svg>
	)
}

export default SvgPk
